import { css } from 'styled-components';
import { focusRing } from '../../utils/mixins';
export const listItemButtonTheme = {
  baseStyle: css(["display:block;width:100%;font-size:14px;text-align:left;text-decoration:none;background-color:transparent;transition:background-color 150ms ease-out;border:none;min-height:40px;color:", ";", " padding:0;", " ", ""], ({
    theme: {
      colors
    }
  }) => colors.text, ({
    alignItems
  }) => alignItems && `align-items: ${alignItems};`, ({
    disablePadding
  }) => !disablePadding && `padding-left: 10px; padding-right: 10px;`, ({
    disableGutters
  }) => !disableGutters && `padding-top: 10px; padding-bottom: 10px;`),
  _hovered: css(["background-color:rgba(0,0,0,0.08);"]),
  _focused: css(["", " outline-offset:-2px;"], focusRing),
  _pressed: css(["background-color:rgba(0,0,0,0.16);"])
};